// Guest layout
import { TYPE_DOC, TYPE_GUEST, SEX } from "../constants";

function getRequiredByMainGuest(record) {
  return record?.main_guest;
}

function layout() {
  const ctxView = {
    model: "hotel.folio.guest",
    selectable: false,
    activeSearch: true,
    filters: null,
    form_action: ["add", "edit"],
    table_action: ["add"],

    fields: {
      main_guest: {
        type: "boolean",
        dependents: [
          "mobile",
          "email",
          "address",
          "nationality",
          "origin_country",
          "target_country",
          "notes",
        ],
      },
      type_guest: {
        type: "selection",
        options: TYPE_GUEST,
        required: true,
        translate: true,
      },
      type_document: {
        type: "selection",
        options: TYPE_DOC,
        required: true,
        translate: true,
      },
      sex: {
        type: "selection",
        options: SEX,
        required: true,
        translate: true,
      },
      id_number: { type: "char", required: true },
      name: { type: "char", required: true },
      mobile: { type: "char", required: getRequiredByMainGuest },
      email: { type: "char", required: getRequiredByMainGuest },
      address: { type: "char", required: getRequiredByMainGuest },
      nationality: {
        type: "many2one",
        model: "country.country",
        limit: 800,
        required: getRequiredByMainGuest,
      },
      origin_country: {
        type: "many2one",
        model: "country.country",
        limit: 800,
        required: getRequiredByMainGuest,
      },
      target_country: {
        type: "many2one",
        model: "country.country",
        limit: 800,
        required: getRequiredByMainGuest,
      },
      birthday: { type: "date_2", required: true },
      notes: { type: "text" },
    },
    list: [
      { name: "name", width: "40%" },
      { name: "type_guest", width: "30%" },
      { name: "main_guest", width: "30%" },
    ],
    form: [
      {
        sm_style: "block",
        name: "personal_data",
        type: "grid",
        col: "md:grid-cols-2",
        elements: [{ name: "id_number" }, { name: "name" }],
      },
      {
        name: "document_data",
        type: "grid",
        col: "grid-cols-2",
        elements: [{ name: "type_document" }, { name: "type_guest" }],
      },
      {
        name: "guest_data",
        type: "grid",
        col: "grid-cols-2",
        elements: [{ name: "birthday" }, { name: "sex" }],
      },
      {
        name: "contact_data",
        type: "grid",
        col: "md:grid-cols-2",
        elements: [{ name: "email" }, { name: "address" }],
      },
      {
        name: "travel_data",
        type: "grid",
        col: "grid-cols-2",
        elements: [{ name: "mobile" }, { name: "nationality" }],
      },
      {
        name: "country",
        type: "grid",
        col: "grid-cols-2",
        elements: [{ name: "origin_country" }, { name: "target_country" }],
      },
      {
        name: "notes_section",
        type: "grid",
        elements: [{ name: "notes" }],
      },
    ],
  };
  return ctxView;
}
export { layout };
